import * as yup from 'yup';
import { SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { UserCreate } from 'store/user/types';
import { validatePhone } from 'utils/utils';

const regexSpecial = /^[aA-zZ0-9.\s]+$/;

const schema = yup.object().shape({
  name: yup.string().required('Campo obrigatório!').min(4, 'Deve conter no mínimo 4 caracteres!'),
  email: yup.string().required('Campo obrigatório!').email('Insira um email válido!'),
  nickname: yup
    .string()
    .matches(regexSpecial, 'Não deve conter caracteres especiais')
    .required('Campo obrigatório!')
    .min(4, 'Deve conter no mínimo 4 caracteres!'),
  pass: yup.string().required('Campo obrigatório!').min(6, 'Deve conter no mínimo 6 caracteres!'),
  phone: yup
    .string()
    .required('Campo obrigatório!')
    .test('invalid-phone', 'Número de celular inválido', (v) => validatePhone(v)),
});

export type SubmitForm = SubmitHandler<UserCreate>;

const ResolverForm = () =>
  useForm<UserCreate>({
    resolver: yupResolver(schema),
    defaultValues: {
      phone: '5500000000000',
    },
  });

export default ResolverForm;
